import { Box } from "@gemini/core";
import { RotateRightIcon } from "@gemini/icons";
import type { ButtonProps } from "@gemini/ui";
import { Button } from "@gemini/ui";
import { useLocation } from "@aviv-unified-frontend/runtime/router";

import { useTranslate } from "../../../utils/useTranslate";

const fullWidth: ButtonProps["isFullWidth"] = {
  "breakpoint.base": true,
  "breakpoint.sm": false,
};

export const GeneralErrorPageButtons = () => {
  const { pathname, search, hash } = useLocation();
  const t = useTranslate();

  return (
    <Box
      paddingHorizontal={{ "breakpoint.base": "spacing.16" }}
      display="inline-flex"
      flexDirection="column"
      alignItems="center"
      alignSelf="stretch"
      gap="spacing.12"
    >
      <Button
        variant="primary"
        isFullWidth={fullWidth}
        icon={RotateRightIcon}
        iconPosition="start"
        href={pathname + search + hash}
      >
        {t("generalError.primaryButton")}
      </Button>
      <Button
        variant="tertiary"
        href="/"
        isFullWidth={fullWidth}
      >
        {t("generalError.secondaryButton")}
      </Button>
    </Box>
  );
};
